/* eslint-disable import/no-duplicates */
/* eslint-disable react/jsx-filename-extension */
import React, { Suspense } from 'react';
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
// import './index.css';
// import './css/index.css';
import { Provider } from 'react-redux';
import awsconfig from './aws-config';
import App from './App';
import Spinner from './elements/Spinner';
import * as serviceWorker from './serviceWorker';
import store from './store';
import hubListener from './hubListener';
import initializeApp from './redux/persist/initializeApp'; // handles rehydration of persisted slices

import './i18n'; // this only runs the code in the file without importing anything
import { ASSET_BASE_URL } from './utils/assetBase';

// this bit of code prepares the index.html using base url specific to the environment
if (ASSET_BASE_URL && typeof document !== 'undefined') {
  window.__ASSET_BASE_URL__ = ASSET_BASE_URL;
  document.documentElement.style.setProperty('--asset-base-url', ASSET_BASE_URL);
  const applyLink = (selector, filename) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute('href', `${ASSET_BASE_URL}${filename}`);
  };
  // Icons live under the asset base; manifest stays at the app root.
  applyLink('link[rel="icon"]', 'favicon.ico');
  applyLink('link[rel="apple-touch-icon"]', 'apple-touch-icon.png');
}

// TODO we don't know if this handles all the callback events from / to Cognito and Stripe correctly
Hub.listen('auth', (capsule) => hubListener(capsule, store));
Hub.listen('core', (capsule) => hubListener(capsule, store));

Amplify.configure(awsconfig);

if (process.env.REACT_APP_ENV_SUFFIX === 'dev') {
  window.myAppStore = store;
}

const container = document.getElementById('root');
const root = createRoot(container);
initializeApp(store).then(() => {
  root.render(
    <React.StrictMode>
      <Suspense fallback={<Spinner />}>
        <Provider store={store}>
          <App />
        </Provider>
      </Suspense>
    </React.StrictMode>,
  );
});

// ReactDOM.render(

//   document.getElementById('root'),
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
